export default function PPBannerComponent() {
    return (
        <div className="banner">
            <a href="https://prastipopieriai.lt/kaunas/" target="_blank" rel="noreferrer" >
                <img className="show-desktop" src="/pp-banner-desktop.jpg" width="1280" height="75" title="Prasti Popieriai - vietos bendruomenių problemų žemėlapis" alt="Prasti Popieriai - vietos bendruomenių problemų žemėlapis" />
                <img className="show-mobile" src="/pp-banner-mobile.jpg" width="320" height="170" title="Prasti Popieriai - vietos bendruomenių problemų žemėlapis" alt="Prasti Popieriai - vietos bendruomenių problemų žemėlapis" />
            </a>
        </div>
    )
}